var map = {
	"./diff_match_patch_uncompressed": 293,
	"./diff_match_patch_uncompressed.js": 293
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1398;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/public/external ^\.\/.*$
 ** module id = 1398
 ** module chunks = 0
 **/